import http from "../utility/http";

/**
 * Create transfer-out (same as portal **Send A Transfer**).
 * Partner Onboarding Step 8d: POST /partner/v1/transfer/transfer-out-request
 * @see portal-be `src/partner-api/docs/onboarding-spec.ts`
 */
const Create = async (transferRequest) => {
  return await http.post("/v1/transfer/transfer-out-request", transferRequest);
};
const Update = async (transferRequest) => {
  return await http.put(`/v1/transfer/transfer-out-request`, transferRequest);
};

const Delete = async (id) => {
  return await http.delete(`/v1/transfer/transfer-out-request/${id}`, {});
};

/**
 * Transfer-out list (paginated). Same contract as Partner Onboarding Step 8b:
 * GET /partner/v1/transfer/transfer-out-request/list?q=&page=&limit=&sortBy=&sortOrder=&statusId=&futureFillOnly=
 * @see portal-be `src/partner-api/docs/onboarding-spec.ts`
 */
const GetAll = async (keyword, page = 1, limit = 50, sort, statusId, futureFillOnly) => {
  //add pagination + sorting + filteration
  let sortQuery = "";
  if (sort) {
    sortQuery = `&sortBy=${sort?.sortBy}&sortOrder=${sort?.sortOrder}`;
  }
  
  let statusQuery = "";
  if (statusId) {
    statusQuery = `&statusId=${statusId}`;
  }

  let futureFillQuery = "";
  if (futureFillOnly) {
    futureFillQuery = "&futureFillOnly=1";
  }
  
  return await http.get(
    `/v1/transfer/transfer-out-request/list?q=${keyword}&page=${page}&limit=${limit}${sortQuery}${statusQuery}${futureFillQuery}`,
    true
  );
};

const GetById = async (id) => {
  return await http.get(`/v1/transfer/transfer-out-request/${id}`);
};

const FinishReview = async (transferRequestAction) => {
  return await http.post(
    "/v1/transfer/transfer-out-request/finish-review",
    transferRequestAction
  );
};

const Reject = async (transferRequestAction) => {
  return await http.post(
    "/v1/transfer/transfer-out-request/reject",
    transferRequestAction
  );
};

const Cancel = async (transferRequestAction) => {
  return await http.post(
    "/v1/transfer/transfer-out-request/cancel",
    transferRequestAction
  );
};

const api = {
  GetById,
  GetAll,
  Create,
  Update,
  Delete,
  Reject,
  Cancel,
  FinishReview,
};

export default api;
